import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const trimEmail = (value) => value.length > 15 ? value.substring(0,12) + "..." : value;

export const Seen = (status) => {
    return status 
                ? <FiberManualRecordIcon sx={{ color: "green",fontSize:"12px" }}  />
                : <FiberManualRecordIcon sx={{ color: "red",fontSize:"12px" }} />;
}